/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function () {
  function repairBlogLinks(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('a.dib-post[aria-label]') && root.textContent.trim()) {
      root.removeAttribute('aria-label');
    }
    root.querySelectorAll('[id*="dropinblog_recentposts"] .dib-post-featured-image, .dib-post-featured-image').forEach(function (img) {
      if (!img.closest('[id*="dropinblog_recentposts"]')) return;
      img.loading = 'lazy';
      img.fetchPriority = 'low';
      img.sizes = 'auto, (max-width: 640px) calc(100vw - 40px), (max-width: 999px) calc(50vw - 40px), 700px';
    });
    root.querySelectorAll('a.dib-post[aria-label]').forEach(function (link) {
      if (link.textContent.trim()) link.removeAttribute('aria-label');
    });
  }
  repairBlogLinks(document);
  document.querySelectorAll('[id*="dropinblog_recentposts"]').forEach(function (host) {
    new MutationObserver(function () { repairBlogLinks(host); }).observe(host, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['aria-label']
    });
  });
})();
